import React from 'react'
import styled from 'styled-components'

import InputItemWrapper from '~/components/Form/InputItemWrapper'
import SimpleInput from '~/components/Form/SimpleInput'

const CodeInput = styled(SimpleInput)`
  font-size: 1.5rem;
  letter-spacing: 0.45em;
  text-align: center;
  text-indent: 0;
  font-variant-numeric: tabular-nums;
  padding-left: 0.45em;
`

const SixDigitCodeInput = ({
  label = '6-Digit Code',
  value,
  onChange,
  disabled = false,
  error = false,
  autoFocus = false,
}) => {
  const handleChange = (event) => {
    const next = event.target.value.replace(/\D/g, '').slice(0, 6)
    onChange(next)
  }

  return (
    <InputItemWrapper label={label} error={error}>
      <CodeInput
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        autoComplete="one-time-code"
        placeholder="000000"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        error={!!error}
        autoFocus={autoFocus}
        aria-label="Six digit login code"
      />
    </InputItemWrapper>
  )
}

export default SixDigitCodeInput
